<mat-sidenav-container class="shell-container">
  <mat-sidenav mode="side" opened class="shell-sidenav">
    <mat-toolbar class="sidenav-header">
      <span class="sidenav-brand"><span class="sidenav-brand__name">EDISON</span> Portal</span>
    </mat-toolbar>
    <mat-nav-list>
      @for (item of navItems; track item.kind === 'link' ? item.route : item.label) {
        @if (item.kind === 'section') {
          <mat-divider class="nav-section-divider" />
          <div class="nav-section-label">{{ item.label }}</div>
        } @else {
          <a mat-list-item
             [routerLink]="item.route"
             routerLinkActive="active-link"
             [routerLinkActiveOptions]="{ exact: item.route === '/dashboard' }">
            <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
            <span matListItemTitle>{{ item.label }}</span>
          </a>
        }
      }
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content class="shell-content" fxLayout="column" fxFlex="1 1 auto">
    <div class="content-header">
      <app-breadcrumbs class="content-breadcrumbs" />
      <span class="content-header-spacer"></span>
      @if (isLocalDevAuth && devSessionActive) {
        <button mat-button [matMenuTriggerFor]="localDevMenu">
          <mat-icon>account_circle</mat-icon>
          <span>Local dev</span>
        </button>
        <mat-menu #localDevMenu="matMenu">
          <button mat-menu-item disabled>
            <mat-icon>shield</mat-icon>
            <span>Local development session</span>
          </button>
          <button mat-menu-item (click)="devLogout()">
            <mat-icon>logout</mat-icon>
            <span>Sign out</span>
          </button>
        </mat-menu>
      } @else if (!isLocalDevAuth && activeAccount) {
        <button mat-button [matMenuTriggerFor]="userMenu">
          <mat-icon>account_circle</mat-icon>
          <span>{{ activeAccount.name }}</span>
        </button>
        <mat-menu #userMenu="matMenu">
          <button mat-menu-item disabled>
            <mat-icon>email</mat-icon>
            <span>{{ activeAccount.username }}</span>
          </button>
          <button mat-menu-item (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>Sign out</span>
          </button>
        </mat-menu>
      } @else {
        <button mat-flat-button (click)="login()">
          <mat-icon>login</mat-icon>
          Sign in
        </button>
      }
    </div>
    <main class="content-area" fxFlex="1 1 auto">
      <router-outlet />
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>
